import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs';
import type { BagFilter } from '../types';

type Props = {
  filter: BagFilter;
  onFilterChange: (filter: BagFilter) => void;
};

const TAB_OPTIONS: { value: BagFilter; label: string }[] = [
  { value: 'todas', label: 'Todas' },
  { value: 'abertas', label: 'Abertas' },
  { value: 'fechadas', label: 'Fechadas' },
  { value: 'etiqueta_gerada', label: 'Etiqueta gerada' },
];

export const BagListTabs = ({ filter, onFilterChange }: Props) => (
  <Tabs value={filter} onValueChange={(v) => onFilterChange(v as BagFilter)}>
    <TabsList>
      {TAB_OPTIONS.map((tab) => (
        <TabsTrigger key={tab.value} value={tab.value}>
          {tab.label}
        </TabsTrigger>
      ))}
    </TabsList>
  </Tabs>
);
